import { z } from 'zod';

import { listDirectory } from './list-directory';
import type {
  GraphListResult,
  GraphServicePrincipal,
  ListServicePrincipalsOptions,
} from './types';

const servicePrincipalSchema: z.ZodType<GraphServicePrincipal> = z
  .object({
    '@odata.type': z.string().optional(),
    appId: z.string().nullish(),
    description: z.string().nullish(),
    displayName: z.string().nullish(),
    id: z.string().optional(),
    servicePrincipalType: z.string().nullish(),
  })
  .passthrough();

/**
 * Lists one page of Microsoft Graph service principals through Backstage's authenticated proxy.
 *
 * @param options - The explicit Graph version, authenticated fetch, query options and transport controls.
 * @returns One validated page. `more`, when present, is a bound zero-argument continuation and can reject with the shared `@ns/http-request` failures.
 */
export function listServicePrincipals(
  options: ListServicePrincipalsOptions,
): Promise<GraphListResult<GraphServicePrincipal>> {
  return listDirectory(options, 'servicePrincipals', servicePrincipalSchema);
}
